import { render, staticRenderFns } from "./BookingDateInputSmall.vue?vue&type=template&id=385d94c8&"
import script from "./BookingDateInputSmall.vue?vue&type=script&lang=js&"
export * from "./BookingDateInputSmall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports